import React, { forwardRef, ReactElement, RefAttributes } from 'react';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { MATERIAL_ICONS } from '../Icon/icons';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { IIconButtonProps, IconButton } from '../IconButton/IconButton';
import { BUTTON_MODES, ButtonVariant, CLOSE_BUTTON_VARIANTS } from '../Button/buttonVariants';
import styled from 'styled-components';

type CloseButtonVariant = Extract<ButtonVariant, 'white50' | 'black50' | 'white50NoSwitch' | 'black50NoSwitch' | 'brandAware'>;

export interface ICloseButtonProps extends Omit<IIconButtonProps, 'icon' | 'iconType' | 'mode'>, Exclude<IIconButtonProps, 'variant'> {
  variant?: CloseButtonVariant;
  minimal?: boolean;
}

const CloseButtonElement = forwardRef<HTMLButtonElement, ICloseButtonProps>(({ size = SIZES.X_SMALL, variant, minimal, ...rest }, ref) => {
  const { generateTestId } = useTestId(rest, 'CloseButton');

  return (
    <IconButton
      mode={minimal ? BUTTON_MODES.MINIMAL : BUTTON_MODES.BOLD}
      icon={MATERIAL_ICONS.Close}
      ref={ref}
      size={size}
      variant={variant ?? CLOSE_BUTTON_VARIANTS.BLACK50}
      {...generateTestId()}
      {...rest}
    />
  );
}) as (props: ICloseButtonProps & RefAttributes<HTMLButtonElement>) => ReactElement<HTMLButtonElement>;

export const CloseButton = styled(CloseButtonElement).attrs<ICloseButtonProps>((args) => ({ ...args }))<ICloseButtonProps>``;
